/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GetFedExTransitTimeResponse
 */
export interface GetFedExTransitTimeResponse {
  /**
   *
   * @type {number}
   * @memberof GetFedExTransitTimeResponse
   */
  transitTime?: number | null;
}

/**
 * Check if a given object implements the GetFedExTransitTimeResponse interface.
 */
export function instanceOfGetFedExTransitTimeResponse(
  value: object,
): value is GetFedExTransitTimeResponse {
  return true;
}

export function GetFedExTransitTimeResponseFromJSON(
  json: any,
): GetFedExTransitTimeResponse {
  return GetFedExTransitTimeResponseFromJSONTyped(json, false);
}

export function GetFedExTransitTimeResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetFedExTransitTimeResponse {
  if (json == null) {
    return json;
  }
  return {
    transitTime: json["transitTime"] == null ? undefined : json["transitTime"],
  };
}

export function GetFedExTransitTimeResponseToJSON(
  json: any,
): GetFedExTransitTimeResponse {
  return GetFedExTransitTimeResponseToJSONTyped(json, false);
}

export function GetFedExTransitTimeResponseToJSONTyped(
  value?: GetFedExTransitTimeResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    transitTime: value["transitTime"],
  };
}
